import { FE_MIGRATE_RETAILER_STORE_250210 } from "@faire/retailer-settings/FE_MIGRATE_RETAILER_STORE_250210";
import { FE_MIGRATE_USE_RETAILER_ONLY_250415 } from "@faire/retailer-settings/FE_MIGRATE_USE_RETAILER_ONLY_250415";
import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingMigrateRetailerStore = () => {
  return useSetting(FE_MIGRATE_RETAILER_STORE_250210);
};

export const useSettingMigrateUseRetailerOnly = () => {
  return useSetting(FE_MIGRATE_USE_RETAILER_ONLY_250415);
};
